import { queryOptions, useQuery } from "@tanstack/react-query";

import type { QueryConfig } from "@/lib/react-query";
import { apiPaths } from "@/config/paths";
import { authApi } from "@/lib/api-client";
import { env } from "@blueskydataplatform/shared-ui/config/env";
import type { Provider } from "@blueskydataplatform/shared-ui/types/providers.types";

const getProvider = (
  providerId?: string | null
): Promise<{
  data: Provider | null;
}> => {
  if (!providerId) {
    return Promise.resolve({ data: null });
  }
  return authApi.get(apiPaths.providers.getProvider.getPath(providerId), {
    baseURL: env.AUTH_API_URL,
  });
};
const getProviderQueryOptions = (providerId?: string | null) => {
  return queryOptions({
    queryKey: ["provider", providerId],
    queryFn: () => getProvider(providerId),
    select: data => data.data,
  });
};

type UseProviderOptions = {
  providerId?: string | null;
  queryConfig?: QueryConfig<typeof getProviderQueryOptions>;
};

export const useProvider = ({ providerId, queryConfig }: UseProviderOptions) => {
  return useQuery({
    ...getProviderQueryOptions(providerId),
    enabled: !!providerId,
    ...queryConfig,
  });
};
